import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SubjectsModel} from '../../shared/subjects.model';
import {Subscription} from 'rxjs/Subscription';
import {PagerServiceService} from '../../shared/services/pager-service/pager-service.service';

@Component({
  selector: 'app-subjects-list',
  templateUrl: './subjects-list.component.html',
  styleUrls: ['./subjects-list.component.css']
})
export class SubjectsListComponent implements OnInit {
  subjectList: any[];
  loading: boolean;
  private allItems: any;
  pager: any = {};
  pagedItems: any[];

  constructor(private httpClient: HttpClient, private pagerService: PagerServiceService) {
  }

  ngOnInit() {
    this.subjectList = [];
    this.getSubjects();
    this.loading = true;

  }

  getSubjects() {
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/subject/list/limit/21/offset/0')
      .subscribe((data: SubjectsModel) => {
        console.log('data', data);
        this.allItems = data.data;
        this.subjectList = this.allItems;
        this.setPage(1);
        this.loading = false;
        console.log('this.all', this.subjectList);
      });
  }
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.subjectList.length, page, 16);

    this.pagedItems = this.subjectList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  deleteQuiz (id) {
    console.log('Subject Id', id);

  }
  openQuiz (id) {
    console.log('Subject Id', id);
  }
}




// WEBPACK FOOTER //
// ./src/app/subjects-list/subjects-list.component.ts